import getApi from '../../api/apisauceConfig'
import { AtcClass } from '../../model/Drug'

export const getAtcClass = (id: number, signal?: AbortSignal) =>
  getApi().get<AtcClass>(`/atc_classifications/${id}`, undefined, { signal })
